/**
 * NexChat i18n — Lightweight internationalization
 * Supported: en, es, fr, zh
 */

import en from './locales/en.js';
import es from './locales/es.js';
import fr from './locales/fr.js';
import zh from './locales/zh.js';

const LOCALES = { en, es, fr, zh };
const LOCALE_NAMES = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  zh: '中文',
};
const RTL_LOCALES = [];

let _locale = 'en';
let _strings = en;

export function initI18n() {
  const saved = localStorage.getItem('nx_locale') || 'en';
  setLocale(saved);
}

export function setLocale(locale) {
  if (!LOCALES[locale]) locale = 'en';
  _locale = locale;
  _strings = LOCALES[locale];
  localStorage.setItem('nx_locale', locale);

  // RTL support
  document.documentElement.dir = RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
  document.documentElement.lang = locale;
}

export function getLocale() { return _locale; }
export function getLocaleNames() { return LOCALE_NAMES; }
export function getSupportedLocales() { return Object.keys(LOCALES); }

/**
 * t('key') — get translation
 * t('key', { count: 3 }) — with variables
 * Supports: {var}, {plural} (adds 's' if count !== 1)
 */
export function t(key, vars = {}) {
  const str = _strings[key] || en[key] || key;
  return str.replace(/\{(\w+)\}/g, (_, k) => {
    if (k === 'plural') {
      const count = vars.count ?? vars.n ?? 1;
      return _locale === 'en' && count !== 1 ? 's' : '';
    }
    return vars[k] !== undefined ? vars[k] : `{${k}}`;
  });
}

export default t;
